import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { message } from "antd";
import { LuRefreshCcw } from "react-icons/lu";
import { FaExclamationTriangle } from "react-icons/fa";

import "./styles.scss";
import SharepointIcon from "../assets/sharepoint-icon.svg"
import SharepointSection, { sharepointLogin } from "./sharepoint";
import { SiteDetailsAction, SiteDetailsReset } from "../../../store/slices/sync-external/siteDetails";

const SyncExternal = () => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [sharepointAccessToken, setSharepointAccessToken] = useState("")
    const [showReconnectSection, setShowReconnectSection] = useState(false)

    const location = useLocation()
    const dispatch = useDispatch()
    const { data: siteDetails, error: siteDetailsError } = useSelector((state) => state?.siteDetails)
    const { isLoading: authDetailsLoading, data: authDetails, error: authError } = useSelector(state => state?.authDetails)

    const handleSelectCard = ({ data }) => {
        if (Object.keys(siteDetails?.data?.sharepoint?.siteDetails || {})?.length === 0) {
        setSelectedOption(prev => (prev?.key === data?.key ? null : data));
            data?.action();
        }
    }

    const connectOptions = [
        {
            key: 1,
            type: "sharepoint",
            defaultActive: !!sharepointAccessToken,
            icon: {
                type: "image",
                src: SharepointIcon,
                alt: "microsoft-sharepoint-icon"
            },
            title: "Connect with Microsoft Sharepoint",
            action: () => !sharepointAccessToken && sharepointLogin(),
            contents: (<SharepointSection />)
        }
    ]
    
    useEffect(() => {
        if ((Object.keys(authDetails || {})?.length > 0 || authError?.message) && !authDetailsLoading) {
            dispatch(SiteDetailsReset())
            dispatch(SiteDetailsAction())
        }
    }, [authDetailsLoading, authDetails])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");

        let connectType = ""

        if (code) {
            connectType = "sharepoint"
        }

        queryParams?.delete("code")
        const matchedOption = connectOptions?.find((opt) => opt?.type === connectType)
        setSelectedOption(matchedOption)

    }, [location])

    useEffect(() => {
        if (siteDetails) {
            setSharepointAccessToken(siteDetails?.data?.sharepoint?.accessToken)
        } else {
            setSharepointAccessToken("")
        }
        if (siteDetails?.data?.sharepoint?.isTokenExpired) {
            setShowReconnectSection(true)
        } else {
            setShowReconnectSection(false)
        }
    }, [siteDetails])

    useEffect(() => {
        if (sharepointAccessToken) {
            setSelectedOption(connectOptions[0])
        }
    }, [sharepointAccessToken])

    useEffect(() => {
        if (siteDetailsError?.message) {
            message?.error(siteDetailsError?.message)
        }
    }, [siteDetailsError?.message])

    return (
        <div className="sync-external-section-container">
            <div className="connect-options">
                {connectOptions?.map((option) => (
                    <div className={`connect-item-card ${Object.keys(siteDetails?.data?.sharepoint?.siteDetails || {})?.length > 0 ? "disable-hover" : ""}`} key={option?.key} onClick={() => handleSelectCard({ data: option })}>
                        <input
                            type="radio"
                            name="connectOption"
                            value={option.key}
                            checked={selectedOption?.key === option?.key}
                            onChange={() => handleSelectCard({ data: option })}
                        />
                        {option?.icon?.type === "image" && (
                            <img alt={option?.icon?.alt} src={option?.icon?.src} className="connect-item-icon" />
                        )}
                        {option?.title}
                    </div>
                ))}
            </div>
            {selectedOption?.contents && (
                <div className="folder-sections">
                    {selectedOption?.contents}
                </div>
            )}
            {showReconnectSection && (
                <div className="reconnect-overlay">
                    <div className="reconnect-section">
                        <div className="header-section">
                            <div className="modal-title">
                                <div className="modal-icon">
                                    <FaExclamationTriangle />
                                </div>
                                Alert
                            </div>
                        </div>
                        <div className="content">
                            Your SharePoint session has expired. Please reconnect to your account to proceed
                        </div>
                        <div className="action-button-container">
                            <div className="reconnect-button" onClick={() => sharepointLogin()}>
                                <LuRefreshCcw /> Reconnect
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SyncExternal